import React, { Dispatch, SetStateAction } from "react";
import AdminModel from "../model/Admin.model";

interface IAppContext {
    breadcrumb: string,
    setBreadcrumb: Dispatch<SetStateAction<string>>
    admin: AdminModel,
}

export const AppContext = React.createContext<IAppContext>({} as IAppContext);
